import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";

const SearchByName = ({ data, value, onSuggestionSelected, placeholder, inputRef }) => {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  useEffect(() => {
    filterNames(typeof value === 'object' && value !== null ? value.nombre : value || "");
  }, [data, value]);

  const filterNames = (val) => {
    const inputValue = (val || "").trim().toLowerCase();

    const filtered = data
      .filter(
        (persona) =>
          persona.nombre &&
          typeof persona.nombre === 'string' &&
          persona.nombre !== "null" &&
          (inputValue === "" || persona.nombre.toLowerCase().includes(inputValue))
      )
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
    
    // En lugar de eliminar duplicados, mostramos todos los registros 
    // para que si dos personas se llaman igual, aparezcan ambas opciones.
    setFilteredSuggestions(filtered);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    filterNames(value);
  };

  const onSuggestionsClearRequested = () => {
    setFilteredSuggestions([]);
  };


  const getSuggestionValue = (suggestion) => suggestion.nombre;


  const renderSuggestion = (suggestion, { isHighlighted }) => {
    // Contamos cuántas veces aparece este mismo nombre exacto en los resultados actuales
    const count = filteredSuggestions.filter(s => s.nombre === suggestion.nombre).length;

    return (
      <div
        className={`suggestion-item ${isHighlighted ? "highlighted" : ""}`}
        onClick={() => onSuggestionSelected(suggestion)}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <span>{suggestion.nombre}</span>
        {count > 1 && suggestion.fecha_def && (
          <span style={{ color: '#888', fontSize: '0.9em', marginLeft: '15px' }}>
            Def: {suggestion.fecha_def}
          </span>
        )}
      </div>
    );
  };
  const handleSuggestionSelected = (_, { suggestion }) => {
    onSuggestionSelected(suggestion);
  };

  // Nuevo: función para manejar los cambios de texto en el input
  const handleInputChange = (_, { newValue }) => {
    onSuggestionSelected(newValue);
  };

  return (
    <div className="suggestion-wrapper">
      <Autosuggest
        suggestions={filteredSuggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={handleSuggestionSelected}
        shouldRenderSuggestions={() => true}
        renderInputComponent={(inputProps) => {
          const { ref, ...rest } = inputProps;
          return (
            <input
              {...rest}
              ref={(el) => {
                if (typeof ref === 'function') ref(el);
                if (inputRef) inputRef.current = el;
              }}
            />
          );
        }}
        inputProps={{
          placeholder: placeholder || "Nombres",
          value: typeof value === 'object' && value !== null ? value.nombre || '' : value,
          // El onChange ahora solo maneja el cambio de texto
          onChange: handleInputChange,
          style: {
            width: "100%",
            height: "40px",
            padding: "8px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
            marginRight: "6px",
          },
        }}
      />
    </div>
  );
};

export default SearchByName;